// extracted by mini-css-extract-plugin
export default {"container":"ResultsBox_container__hew8d","results":"ResultsBox_results__PDyRJ","noResults":"ResultsBox_noResults__rfnEG"};